import React from 'react';
import './PackageCard.css';

import * as FaIcons from 'react-icons/fa';

const FaPlane = FaIcons.FaPlane as unknown as React.FC;
const FaHotel = FaIcons.FaHotel as unknown as React.FC;
const FaUtensils = FaIcons.FaUtensils as unknown as React.FC;
const FaSpa = FaIcons.FaSpa as unknown as React.FC;
const FaUmbrellaBeach = FaIcons.FaUmbrellaBeach as unknown as React.FC;
const FaCar = FaIcons.FaCar as unknown as React.FC;
const FaShip = FaIcons.FaShip as unknown as React.FC;
const FaEye = FaIcons.FaEye as unknown as React.FC;
const FaAngellist = FaIcons.FaAngellist as unknown as React.FC;

interface PackageCardProps {
  image: string;
  title: string;
  tag?: string;
  duration: string;
  features: string[];
  inclusions: string[];
  highlight?: string;
  pricePerPerson: number;
}

const inclusionIcons: Record<string, React.ReactNode > = {
  flight: <FaPlane />,
  hotel: <FaHotel />,
  meals: <FaUtensils />,
  food: <FaUtensils />,
  spa: <FaSpa />,
  beach: <FaUmbrellaBeach />,
  transfers: <FaCar />,
  sightseeing: <FaEye />,
  cruise: <FaShip />,
};

function getInclusionIcon(label: string): React.ReactNode {
  const key = label.toLowerCase().trim();
  return inclusionIcons[key] || <span>{label}</span>;
}

export default function PackageCard({
  image,
  title,
  tag,
  duration,
  features,
  inclusions,
  highlight,
  pricePerPerson
}: PackageCardProps) {
  return (
    <div className="package-card">
      <img src={image} alt={title} className="package-image" />

      <div className="package-details">
        <div className="package-header">
          <div className="package-title">{title}</div>
          <div className="package-duration">{duration}</div>
          {tag && <span className="package-tag">{tag}</span>}
        </div>

        <div className="package-highlight-block">
        <ul className="package-features">
          {features.map((f, i) => (
            <li key={i}>• {f}</li>
          ))}
        </ul>

        <div className="package-inclusions">
          {inclusions.map((inc, i) => (
            <span className="inclusion-icon" key={i} title={inc}>
              {getInclusionIcon(inc)}
            </span>
          ))}
        </div>

          {highlight && <div className="package-highlight"><FaAngellist /> {highlight}</div>}
          <div className="package-price">₹{pricePerPerson.toLocaleString('en-IN')}/Person</div>
          <button className="primary-button">Book Now</button>
          </div>
      </div>
    </div>
  );
}
